import { render, staticRenderFns } from "./WikipediaIcon.vue?vue&type=template&id=18fc753b&scoped=true"
import script from "./WikipediaIcon.vue?vue&type=script&lang=js"
export * from "./WikipediaIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fc753b",
  null
  
)

export default component.exports